<template>
  <v-data-table :headers="headers" :items="plans" item-key="id" :loading="loading" height="210" class="elevation-0 content" dense hide-default-footer single-select fixed-header>
    <template v-slot:item.plan="{ item }">
      <span v-for="index in item.depth" :key="index" class="depth">▷</span>
      {{ item.operation }}
      <span v-if="item.options">({{ item.options }})</span>
      <span v-if="item.objectName"> OF '{{ item.objectName }}'</span>
      <span v-if="item.objectType"> ({{ item.objectType }})</span>
      <span v-if="item.optimizer"> Optimizer={{ item.optimizer }}</span>
      <span> (Cost={{ item.cost }} Card={{ item.cardinality }} Bytes={{ item.bytes }})</span>
    </template>
  </v-data-table>
</template>

<script>
import { api } from '../../../api/common/instances';

export default {
  props: {
    sql: Object,
  },
  data() {
    return {
      headers: [
        { text: 'ID', value: 'id', sortable: false, width: '5%' },
        { text: 'PID', value: 'parentId', sortable: false, width: '5%' },
        { text: 'Plan for SQL Statement', value: 'plan', sortable: false },
      ],
      plans: [],
      loading: false,
    };
  },
  watch: {
    async sql(value) {
      this.loading = true;
      ({ data: this.plans } = await api('/analysis/sqlviewer/plan-list', {
        params: {
          sampleTime: value.sampleTime,
          sstmId: value.sstmId,
          sqlId: value.sqlId,
          sqlChildNumber: value.sqlChildNumber,
          sessionSerial: value.sessionSerial,
        },
      }));
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.depth {
  margin-right: 3px;
}
</style>
